export default "__VITE_ASSET__dh6M8lfO__"